var __decorate=this&&this.__decorate||function(e,t,i,o){var r,n=arguments.length,a=n<3?t:null===o?o=Object.getOwnPropertyDescriptor(t,i):o;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,i,o);else for(var l=e.length-1;l>=0;l--)(r=e[l])&&(a=(n<3?r(a):n>3?r(t,i,a):r(t,i))||a);return n>3&&a&&Object.defineProperty(t,i,a),a};import{css as e,html as t,unsafeCSS as i}from"lit";import{OrElement as o}from"@openremote/or-element";import{customElement as r,property as n,query as a}from"lit/decorators.js";import{i18next as l}from"@openremote/or-translate";import{DefaultColor5 as d}from"@openremote/core";import{until as s}from"lit/directives/until.js";let style=e`
  :host {
    display: block;
    box-sizing: content-box;
    margin: 0;
    overflow: hidden;
    transition:
      margin 225ms cubic-bezier(0.4, 0, 0.2, 1),
      box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    border-color: var(--or-app-color5, ${i(d)});
    background-color: var(--or-collapisble-panel-background-color);
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
  }

  :host([hidden]) {
    display: none;
  }

  #header {
    display: flex;
    height: 48px;
    flex-direction: row;
    font-family:
      Roboto,
      Helvetica Neue,
      sans-serif;
    font-size: 15px;
    font-weight: 400;
    align-items: center;
    padding: 0 16px 0 16px;
    border-radius: inherit;
  }

  #header.expandable {
    cursor: pointer;
    transition: height 225ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  #header.expanded {
    height: 64px;
  }

  #header.expanded > #indicator {
  }

  #header-content {
    flex: 1;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    min-width: 0; /* Allows the element to shrink */
  }

  #header-title {
    min-width: 0; /* Allows the element to shrink */
  }

  #header-title,
  #header-description {
    display: inline-flex;
    align-items: center;
  }

  #header-description {
    flex-grow: 2;
  }

  #indicator {
    align-self: center;
    margin-right: 6px;
    margin-left: -5px;
  }

  #content {
    height: 0;
    visibility: hidden;
  }

  #content.expanded {
    height: unset;
    visibility: visible;
  }

  or-icon {
    vertical-align: middle;
    --or-icon-width: 20px;
    --or-icon-height: 20px;
    margin-right: 2px;
    margin-left: -5px;
  }
`,OrCollapsiblePanel=class extends o{constructor(){super(...arguments),this.expanded=!1,this.expandable=!0}static get styles(){return[style]}_onHeaderClicked(e){this.expandable&&(e.preventDefault(),this.expanded=!this.expanded)}render(){return t`
      <div
        id="header"
        class="${this.expandable?"expandable":""} ${this.expandable&&this.expanded?"expanded":""}"
        @click="${e=>this._onHeaderClicked(e)}"
      >
        ${this.expandable?t`<or-icon icon="chevron-${this.expanded?"down":"right"}"></or-icon>`:""}
        <span id="header-content">
          <span id="header-title"><slot name="header"></slot></span>
          <span id="header-description"><slot name="header-description"></slot></span>
        </span>
      </div>
      <div id="content" class="${this.expandable&&this.expanded?"expanded":""}">
        ${this.lazycontent?this.expanded&&s(this.lazycontent,t`${l.t("loading")}`):t`<slot name="content"></slot>`}
      </div>
    `}};__decorate([n({type:Promise})],OrCollapsiblePanel.prototype,"lazycontent",void 0),__decorate([n({type:Boolean})],OrCollapsiblePanel.prototype,"expanded",void 0),__decorate([n({type:Boolean})],OrCollapsiblePanel.prototype,"expandable",void 0),__decorate([a("#header")],OrCollapsiblePanel.prototype,"headerElem",void 0),OrCollapsiblePanel=__decorate([r("or-collapsible-panel")],OrCollapsiblePanel);export{OrCollapsiblePanel};